export default __webpack_public_path__ + "static/10-3--c30b9486aced9c83939ea342bc10f0c4.png";